import React from 'react';
import styled from 'styled-components';
import { Button, Flex, Text, Tooltip } from 'core/components';
import { TbChevronsLeft, TbChevronsRight } from 'react-icons/tb';

interface CollapsedPanelStripProps {
  label: string;
  /** Which side the strip expands toward when clicked. */
  direction: 'left' | 'right';
  onClick: () => void;
}

const StripContainer = styled(Flex)`
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 40px;
  cursor: pointer;
  background: ${(props) => props.theme.colors.cardBackground};
  border: 1px solid ${(props) => props.theme.borderColors.thin};
  border-radius: 6px;

  &:hover {
    background: ${(props) => props.theme.colors.sectionBackground};
  }
`;

const RotatedLabel = styled(Text)`
  writing-mode: vertical-rl;
  text-orientation: mixed;
  transform: rotate(180deg);
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  user-select: none;
`;

const CollapsedPanelStrip = ({ label, direction, onClick }: CollapsedPanelStripProps) => {
  const ExpandIcon = direction === 'left' ? TbChevronsRight : TbChevronsLeft;
  const tooltipContent = `Open ${label} options`;

  return (
    <StripContainer flexDirection="column" gap={2} my="12px" mr={direction === 'left' ? '4px' : 0} onClick={onClick}>
      <Flex pt="8px" justifyContent="center">
        <Tooltip content={tooltipContent}>
          <Button
            minimal
            icon={ExpandIcon}
            aria-label={tooltipContent}
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              onClick();
            }}
          />
        </Tooltip>
      </Flex>
      <RotatedLabel muted>{label}</RotatedLabel>
    </StripContainer>
  );
};

export default CollapsedPanelStrip;
